import React from "react";
import { Link } from "react-router-dom";

const SUBMIT_COPY = {
  edit: {
    title: "Зберегти зміни?",
    text: "Зміни в профілі стануть видимі іншим користувачам одразу після збереження.",
    submitLabel: "Зберегти зміни",
    submitIcon: "fa-floppy-disk",
  },
  onboarding: {
    title: "Готові продовжити?",
    text: "Перевірте дані ще раз і завершіть реєстрацію — після цього ви потрапите у свій профіль.",
    submitLabel: "Завершити реєстрацію",
    submitIcon: "fa-circle-check",
  },
};

function SubmitSection({ onboardingMode = false, disabled = false }) {
  const copy = onboardingMode ? SUBMIT_COPY.onboarding : SUBMIT_COPY.edit;

  return (
    <section
      className="ap-final"
      aria-labelledby="ep-pane-submit"
      data-section="submit"
      data-mode={onboardingMode ? "onboarding" : "edit"}
    >
      <h3 id="ep-pane-submit">{copy.title}</h3>
      <p>{copy.text}</p>
      <div className="ap-final__actions">
        {!onboardingMode && (
          <Link to="/" className="action-btn" data-action="cancel">
            <i className="fa-solid fa-xmark" aria-hidden="true"></i>Скасувати
          </Link>
        )}
        <button
          type="submit"
          className="btn-more"
          data-action="submit"
          disabled={disabled}
          aria-disabled={disabled ? "true" : undefined}
        >
          <i className={`fa-solid ${copy.submitIcon}`} aria-hidden="true"></i>
          {copy.submitLabel}
        </button>
      </div>
    </section>
  );
}

export default SubmitSection;
